import { memo } from 'react';
import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

const ZoomIcon = (props: IconWrapperProps) => (
  <IconWrapper width="20px" viewBox="0 0 24 24" id="export-outline" {...props}>
    <path
      fill="currentColor"
      d="M19.45,18A11,11,0,1,0,18,19.45L21.59,23A1,1,0,0,0,23,23h0a1,1,0,0,0,0-1.41ZM11,20a9,9,0,1,1,9-9A9,9,0,0,1,11,20Zm1-10h3a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1H12v3a1,1,0,0,1-1,1h0a1,1,0,0,1-1-1V12H7a1,1,0,0,1-1-1H6a1,1,0,0,1,1-1h3V7a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1Z"
    />
  </IconWrapper>
);

export default memo(ZoomIcon);
